import React from 'react';
import GithubSvgIcon from '../../../icons/github.svg';

// A React component to be rendered in the top-right corner of a content page
// eslint-disable-next-line react/display-name
export default () => {
  return (
    <div>
      <GithubSvgIcon />
    </div>
  );
};
